/* eslint-disable max-lines */

export interface CountryDialCodeDto {
  countryDialCode: string;
  dialCodeValue: string;
  dialCodeName: string;
  // internal
  id?: string;
  name?: string;
  flagClass?: string;
}

export const COUNTRY_DIAL_CODES: CountryDialCodeDto[] = [
  {
    countryDialCode: 'AF',
    dialCodeValue: '93',
    dialCodeName: 'Afghanistan (‫افغانستان‬‎)',
    id: '93',
    name: 'Afghanistan (‫افغانستان‬‎) +93',
  },
  {
    countryDialCode: 'AL',
    dialCodeValue: '355',
    dialCodeName: 'Albania (Shqipëri)',
    id: '355',
    name: 'Albania (Shqipëri) +355',
  },
  {
    countryDialCode: 'DZ',
    dialCodeValue: '213',
    dialCodeName: 'Algeria (‫الجزائر‬‎)',
    id: '213',
    name: 'Algeria (‫الجزائر‬‎) +213',
  },
  {
    countryDialCode: 'AS',
    dialCodeValue: '1684',
    dialCodeName: 'American Samoa',
    id: '1684',
    name: 'American Samoa +1684',
  },
  {
    countryDialCode: 'AD',
    dialCodeValue: '376',
    dialCodeName: 'Andorra',
    id: '376',
    name: 'Andorra +376',
  },
  {
    countryDialCode: 'AO',
    dialCodeValue: '244',
    dialCodeName: 'Angola',
    id: '244',
    name: 'Angola +244',
  },
  {
    countryDialCode: 'AI',
    dialCodeValue: '1264',
    dialCodeName: 'Anguilla',
    id: '1264',
    name: 'Anguilla +1264',
  },
  {
    countryDialCode: 'AG',
    dialCodeValue: '1268',
    dialCodeName: 'Antigua and Barbuda',
    id: '1268',
    name: 'Antigua and Barbuda +1268',
  },
  {
    countryDialCode: 'AR',
    dialCodeValue: '54',
    dialCodeName: 'Argentina',
    id: '54',
    name: 'Argentina +54',
  },
  {
    countryDialCode: 'AM',
    dialCodeValue: '374',
    dialCodeName: 'Armenia (Հայաստան)',
    id: '374',
    name: 'Armenia (Հայաստան) +374',
  },
  {
    countryDialCode: 'AW',
    dialCodeValue: '297',
    dialCodeName: 'Aruba',
    id: '297',
    name: 'Aruba +297',
  },
  {
    countryDialCode: 'AU',
    dialCodeValue: '61',
    dialCodeName: 'Australia',
    id: '61',
    name: 'Australia +61',
  },
  {
    countryDialCode: 'AT',
    dialCodeValue: '43',
    dialCodeName: 'Austria (Österreich)',
    id: '43',
    name: 'Austria (Österreich) +43',
  },
  {
    countryDialCode: 'AZ',
    dialCodeValue: '994',
    dialCodeName: 'Azerbaijan (Azərbaycan)',
    id: '994',
    name: 'Azerbaijan (Azərbaycan) +994',
  },
  {
    countryDialCode: 'BS',
    dialCodeValue: '1242',
    dialCodeName: 'Bahamas',
    id: '1242',
    name: 'Bahamas +1242',
  },
  {
    countryDialCode: 'BH',
    dialCodeValue: '973',
    dialCodeName: 'Bahrain (‫البحرين‬‎)',
    id: '973',
    name: 'Bahrain (‫البحرين‬‎) +973',
  },
  {
    countryDialCode: 'BD',
    dialCodeValue: '880',
    dialCodeName: 'Bangladesh (বাংলাদেশ)',
    id: '880',
    name: 'Bangladesh (বাংলাদেশ) +880',
  },
  {
    countryDialCode: 'BB',
    dialCodeValue: '1246',
    dialCodeName: 'Barbados',
    id: '1246',
    name: 'Barbados +1246',
  },
  {
    countryDialCode: 'BY',
    dialCodeValue: '375',
    dialCodeName: 'Belarus (Беларусь)',
    id: '375',
    name: 'Belarus (Беларусь) +375',
  },
  {
    countryDialCode: 'BE',
    dialCodeValue: '32',
    dialCodeName: 'Belgium (België)',
    id: '32',
    name: 'Belgium (België) +32',
  },
  {
    countryDialCode: 'BZ',
    dialCodeValue: '501',
    dialCodeName: 'Belize',
    id: '501',
    name: 'Belize +501',
  },
  {
    countryDialCode: 'BJ',
    dialCodeValue: '229',
    dialCodeName: 'Benin (Bénin)',
    id: '229',
    name: 'Benin (Bénin) +229',
  },
  {
    countryDialCode: 'BM',
    dialCodeValue: '1441',
    dialCodeName: 'Bermuda',
    id: '1441',
    name: 'Bermuda +1441',
  },
  {
    countryDialCode: 'BT',
    dialCodeValue: '975',
    dialCodeName: 'Bhutan (འབྲུག)',
    id: '975',
    name: 'Bhutan (འབྲུག) +975',
  },
  {
    countryDialCode: 'BO',
    dialCodeValue: '591',
    dialCodeName: 'Bolivia',
    id: '591',
    name: 'Bolivia +591',
  },
  {
    countryDialCode: 'BA',
    dialCodeValue: '387',
    dialCodeName: 'Bosnia and Herzegovina (Босна и Херцеговина)',
    id: '387',
    name: 'Bosnia and Herzegovina (Босна и Херцеговина) +387',
  },
  {
    countryDialCode: 'BW',
    dialCodeValue: '267',
    dialCodeName: 'Botswana',
    id: '267',
    name: 'Botswana +267',
  },
  {
    countryDialCode: 'BR',
    dialCodeValue: '55',
    dialCodeName: 'Brazil (Brasil)',
    id: '55',
    name: 'Brazil (Brasil) +55',
  },
  {
    countryDialCode: 'IO',
    dialCodeValue: '246',
    dialCodeName: 'British Indian Ocean Territory',
    id: '246',
    name: 'British Indian Ocean Territory +246',
  },
  {
    countryDialCode: 'VG',
    dialCodeValue: '1284',
    dialCodeName: 'British Virgin Islands',
    id: '1284',
    name: 'British Virgin Islands +1284',
  },
  {
    countryDialCode: 'BN',
    dialCodeValue: '673',
    dialCodeName: 'Brunei',
    id: '673',
    name: 'Brunei +673',
  },
  {
    countryDialCode: 'BG',
    dialCodeValue: '359',
    dialCodeName: 'Bulgaria (България)',
    id: '359',
    name: 'Bulgaria (България) +359',
  },
  {
    countryDialCode: 'BF',
    dialCodeValue: '226',
    dialCodeName: 'Burkina Faso',
    id: '226',
    name: 'Burkina Faso +226',
  },
  {
    countryDialCode: 'BI',
    dialCodeValue: '257',
    dialCodeName: 'Burundi (Uburundi)',
    id: '257',
    name: 'Burundi (Uburundi) +257',
  },
  {
    countryDialCode: 'KH',
    dialCodeValue: '855',
    dialCodeName: 'Cambodia (កម្ពុជា)',
    id: '855',
    name: 'Cambodia (កម្ពុជា) +855',
  },
  {
    countryDialCode: 'CM',
    dialCodeValue: '237',
    dialCodeName: 'Cameroon (Cameroun)',
    id: '237',
    name: 'Cameroon (Cameroun) +237',
  },
  {
    countryDialCode: 'CA',
    dialCodeValue: '1',
    dialCodeName: 'Canada',
    id: '1',
    name: 'Canada +1',
  },
  {
    countryDialCode: 'CV',
    dialCodeValue: '238',
    dialCodeName: 'Cape Verde (Kabu Verdi)',
    id: '238',
    name: 'Cape Verde (Kabu Verdi) +238',
  },
  {
    countryDialCode: 'BQ',
    dialCodeValue: '599',
    dialCodeName: 'Caribbean Netherlands',
    id: '599',
    name: 'Caribbean Netherlands +599',
  },
  {
    countryDialCode: 'KY',
    dialCodeValue: '1345',
    dialCodeName: 'Cayman Islands',
    id: '1345',
    name: 'Cayman Islands +1345',
  },
  {
    countryDialCode: 'CF',
    dialCodeValue: '236',
    dialCodeName: 'Central African Republic (République centrafricaine)',
    id: '236',
    name: 'Central African Republic (République centrafricaine) +236',
  },
  {
    countryDialCode: 'TD',
    dialCodeValue: '235',
    dialCodeName: 'Chad (Tchad)',
    id: '235',
    name: 'Chad (Tchad) +235',
  },
  {
    countryDialCode: 'CL',
    dialCodeValue: '56',
    dialCodeName: 'Chile',
    id: '56',
    name: 'Chile +56',
  },
  {
    countryDialCode: 'CN',
    dialCodeValue: '86',
    dialCodeName: 'China (中国)',
    id: '86',
    name: 'China (中国) +86',
  },
  {
    countryDialCode: 'CX',
    dialCodeValue: '61',
    dialCodeName: 'Christmas Island',
    id: '61',
    name: 'Christmas Island +61',
  },
  {
    countryDialCode: 'CC',
    dialCodeValue: '61',
    dialCodeName: 'Cocos (Keeling) Islands',
    id: '61',
    name: 'Cocos (Keeling) Islands +61',
  },
  {
    countryDialCode: 'CO',
    dialCodeValue: '57',
    dialCodeName: 'Colombia',
    id: '57',
    name: 'Colombia +57',
  },
  {
    countryDialCode: 'KM',
    dialCodeValue: '269',
    dialCodeName: 'Comoros (‫جزر القمر‬‎)',
    id: '269',
    name: 'Comoros (‫جزر القمر‬‎) +269',
  },
  {
    countryDialCode: 'CD',
    dialCodeValue: '243',
    dialCodeName: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
    id: '243',
    name: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo) +243',
  },
  {
    countryDialCode: 'CG',
    dialCodeValue: '242',
    dialCodeName: 'Congo (Republic) (Congo-Brazzaville)',
    id: '242',
    name: 'Congo (Republic) (Congo-Brazzaville) +242',
  },
  {
    countryDialCode: 'CK',
    dialCodeValue: '682',
    dialCodeName: 'Cook Islands',
    id: '682',
    name: 'Cook Islands +682',
  },
  {
    countryDialCode: 'CR',
    dialCodeValue: '506',
    dialCodeName: 'Costa Rica',
    id: '506',
    name: 'Costa Rica +506',
  },
  {
    countryDialCode: 'HR',
    dialCodeValue: '385',
    dialCodeName: 'Croatia (Hrvatska)',
    id: '385',
    name: 'Croatia (Hrvatska) +385',
  },
  {
    countryDialCode: 'CU',
    dialCodeValue: '53',
    dialCodeName: 'Cuba',
    id: '53',
    name: 'Cuba +53',
  },
  {
    countryDialCode: 'CW',
    dialCodeValue: '599',
    dialCodeName: 'Curacao',
    id: '599',
    name: 'Curacao +599',
  },
  {
    countryDialCode: 'CY',
    dialCodeValue: '357',
    dialCodeName: 'Cyprus (Κύπρος)',
    id: '357',
    name: 'Cyprus (Κύπρος) +357',
  },
  {
    countryDialCode: 'CZ',
    dialCodeValue: '420',
    dialCodeName: 'Czech Republic (Česká republika)',
    id: '420',
    name: 'Czech Republic (Česká republika) +420',
  },
  {
    countryDialCode: 'CI',
    dialCodeValue: '225',
    dialCodeName: 'Côte d’Ivoire',
    id: '225',
    name: 'Côte d’Ivoire +225',
  },
  {
    countryDialCode: 'DK',
    dialCodeValue: '45',
    dialCodeName: 'Denmark (Danmark)',
    id: '45',
    name: 'Denmark (Danmark) +45',
  },
  {
    countryDialCode: 'DJ',
    dialCodeValue: '253',
    dialCodeName: 'Djibouti',
    id: '253',
    name: 'Djibouti +253',
  },
  {
    countryDialCode: 'DM',
    dialCodeValue: '1767',
    dialCodeName: 'Dominica',
    id: '1767',
    name: 'Dominica +1767',
  },
  {
    countryDialCode: 'DO',
    dialCodeValue: '1',
    dialCodeName: 'Dominican Republic (República Dominicana)',
    id: '1',
    name: 'Dominican Republic (República Dominicana) +1',
  },
  {
    countryDialCode: 'EC',
    dialCodeValue: '593',
    dialCodeName: 'Ecuador',
    id: '593',
    name: 'Ecuador +593',
  },
  {
    countryDialCode: 'EG',
    dialCodeValue: '20',
    dialCodeName: 'Egypt (‫مصر‬‎)',
    id: '20',
    name: 'Egypt (‫مصر‬‎) +20',
  },
  {
    countryDialCode: 'SV',
    dialCodeValue: '503',
    dialCodeName: 'El Salvador',
    id: '503',
    name: 'El Salvador +503',
  },
  {
    countryDialCode: 'GQ',
    dialCodeValue: '240',
    dialCodeName: 'Equatorial Guinea (Guinea Ecuatorial)',
    id: '240',
    name: 'Equatorial Guinea (Guinea Ecuatorial) +240',
  },
  {
    countryDialCode: 'ER',
    dialCodeValue: '291',
    dialCodeName: 'Eritrea',
    id: '291',
    name: 'Eritrea +291',
  },
  {
    countryDialCode: 'EE',
    dialCodeValue: '372',
    dialCodeName: 'Estonia (Eesti)',
    id: '372',
    name: 'Estonia (Eesti) +372',
  },
  {
    countryDialCode: 'ET',
    dialCodeValue: '251',
    dialCodeName: 'Ethiopia',
    id: '251',
    name: 'Ethiopia +251',
  },
  {
    countryDialCode: 'FK',
    dialCodeValue: '500',
    dialCodeName: 'Falkland Islands (Islas Malvinas)',
    id: '500',
    name: 'Falkland Islands (Islas Malvinas) +500',
  },
  {
    countryDialCode: 'FO',
    dialCodeValue: '298',
    dialCodeName: 'Faroe Islands (Føroyar)',
    id: '298',
    name: 'Faroe Islands (Føroyar) +298',
  },
  {
    countryDialCode: 'FJ',
    dialCodeValue: '679',
    dialCodeName: 'Fiji',
    id: '679',
    name: 'Fiji +679',
  },
  {
    countryDialCode: 'FI',
    dialCodeValue: '358',
    dialCodeName: 'Finland (Suomi)',
    id: '358',
    name: 'Finland (Suomi) +358',
  },
  {
    countryDialCode: 'FR',
    dialCodeValue: '33',
    dialCodeName: 'France',
    id: '33',
    name: 'France +33',
  },
  {
    countryDialCode: 'GF',
    dialCodeValue: '594',
    dialCodeName: 'French Guiana (Guyane française)',
    id: '594',
    name: 'French Guiana (Guyane française) +594',
  },
  {
    countryDialCode: 'PF',
    dialCodeValue: '689',
    dialCodeName: 'French Polynesia (Polynésie française)',
    id: '689',
    name: 'French Polynesia (Polynésie française) +689',
  },
  {
    countryDialCode: 'GA',
    dialCodeValue: '241',
    dialCodeName: 'Gabon',
    id: '241',
    name: 'Gabon +241',
  },
  {
    countryDialCode: 'GM',
    dialCodeValue: '220',
    dialCodeName: 'Gambia',
    id: '220',
    name: 'Gambia +220',
  },
  {
    countryDialCode: 'GE',
    dialCodeValue: '995',
    dialCodeName: 'Georgia (საქართველო)',
    id: '995',
    name: 'Georgia (საქართველო) +995',
  },
  {
    countryDialCode: 'DE',
    dialCodeValue: '49',
    dialCodeName: 'Germany (Deutschland)',
    id: '49',
    name: 'Germany (Deutschland) +49',
  },
  {
    countryDialCode: 'GH',
    dialCodeValue: '233',
    dialCodeName: 'Ghana (Gaana)',
    id: '233',
    name: 'Ghana (Gaana) +233',
  },
  {
    countryDialCode: 'GI',
    dialCodeValue: '350',
    dialCodeName: 'Gibraltar',
    id: '350',
    name: 'Gibraltar +350',
  },
  {
    countryDialCode: 'GR',
    dialCodeValue: '30',
    dialCodeName: 'Greece (Ελλάδα)',
    id: '30',
    name: 'Greece (Ελλάδα) +30',
  },
  {
    countryDialCode: 'GL',
    dialCodeValue: '299',
    dialCodeName: 'Greenland (Kalaallit Nunaat)',
    id: '299',
    name: 'Greenland (Kalaallit Nunaat) +299',
  },
  {
    countryDialCode: 'GD',
    dialCodeValue: '1473',
    dialCodeName: 'Grenada',
    id: '1473',
    name: 'Grenada +1473',
  },
  {
    countryDialCode: 'GP',
    dialCodeValue: '590',
    dialCodeName: 'Guadeloupe',
    id: '590',
    name: 'Guadeloupe +590',
  },
  {
    countryDialCode: 'GU',
    dialCodeValue: '1671',
    dialCodeName: 'Guam',
    id: '1671',
    name: 'Guam +1671',
  },
  {
    countryDialCode: 'GT',
    dialCodeValue: '502',
    dialCodeName: 'Guatemala',
    id: '502',
    name: 'Guatemala +502',
  },
  {
    countryDialCode: 'GG',
    dialCodeValue: '44',
    dialCodeName: 'Guernsey',
    id: '44',
    name: 'Guernsey +44',
  },
  {
    countryDialCode: 'GN',
    dialCodeValue: '224',
    dialCodeName: 'Guinea (Guinée)',
    id: '224',
    name: 'Guinea (Guinée) +224',
  },
  {
    countryDialCode: 'GW',
    dialCodeValue: '245',
    dialCodeName: 'Guinea-Bissau (Guiné Bissau)',
    id: '245',
    name: 'Guinea-Bissau (Guiné Bissau) +245',
  },
  {
    countryDialCode: 'GY',
    dialCodeValue: '592',
    dialCodeName: 'Guyana',
    id: '592',
    name: 'Guyana +592',
  },
  {
    countryDialCode: 'HT',
    dialCodeValue: '509',
    dialCodeName: 'Haiti',
    id: '509',
    name: 'Haiti +509',
  },
  {
    countryDialCode: 'HN',
    dialCodeValue: '504',
    dialCodeName: 'Honduras',
    id: '504',
    name: 'Honduras +504',
  },
  {
    countryDialCode: 'HK',
    dialCodeValue: '852',
    dialCodeName: 'Hong Kong (香港)',
    id: '852',
    name: 'Hong Kong (香港) +852',
  },
  {
    countryDialCode: 'HU',
    dialCodeValue: '36',
    dialCodeName: 'Hungary (Magyarország)',
    id: '36',
    name: 'Hungary (Magyarország) +36',
  },
  {
    countryDialCode: 'IS',
    dialCodeValue: '354',
    dialCodeName: 'Iceland (Ísland)',
    id: '354',
    name: 'Iceland (Ísland) +354',
  },
  {
    countryDialCode: 'IN',
    dialCodeValue: '91',
    dialCodeName: 'India (भारत)',
    id: '91',
    name: 'India (भारत) +91',
  },
  {
    countryDialCode: 'ID',
    dialCodeValue: '62',
    dialCodeName: 'Indonesia',
    id: '62',
    name: 'Indonesia +62',
  },
  {
    countryDialCode: 'IR',
    dialCodeValue: '98',
    dialCodeName: 'Iran (‫ایران‬‎)',
    id: '98',
    name: 'Iran (‫ایران‬‎) +98',
  },
  {
    countryDialCode: 'IQ',
    dialCodeValue: '964',
    dialCodeName: 'Iraq (‫العراق‬‎)',
    id: '964',
    name: 'Iraq (‫العراق‬‎) +964',
  },
  {
    countryDialCode: 'IE',
    dialCodeValue: '353',
    dialCodeName: 'Ireland',
    id: '353',
    name: 'Ireland +353',
  },
  {
    countryDialCode: 'IM',
    dialCodeValue: '44',
    dialCodeName: 'Isle of Man',
    id: '44',
    name: 'Isle of Man +44',
  },
  {
    countryDialCode: 'IL',
    dialCodeValue: '972',
    dialCodeName: 'Israel (‫ישראל‬‎)',
    id: '972',
    name: 'Israel (‫ישראל‬‎) +972',
  },
  {
    countryDialCode: 'IT',
    dialCodeValue: '39',
    dialCodeName: 'Italy (Italia)',
    id: '39',
    name: 'Italy (Italia) +39',
  },
  {
    countryDialCode: 'JM',
    dialCodeValue: '1',
    dialCodeName: 'Jamaica',
    id: '1',
    name: 'Jamaica +1',
  },
  {
    countryDialCode: 'JP',
    dialCodeValue: '81',
    dialCodeName: 'Japan (日本)',
    id: '81',
    name: 'Japan (日本) +81',
  },
  {
    countryDialCode: 'JE',
    dialCodeValue: '44',
    dialCodeName: 'Jersey',
    id: '44',
    name: 'Jersey +44',
  },
  {
    countryDialCode: 'JO',
    dialCodeValue: '962',
    dialCodeName: 'Jordan (‫الأردن‬‎)',
    id: '962',
    name: 'Jordan (‫الأردن‬‎) +962',
  },
  {
    countryDialCode: 'KZ',
    dialCodeValue: '7',
    dialCodeName: 'Kazakhstan (Казахстан)',
    id: '7',
    name: 'Kazakhstan (Казахстан) +7',
  },
  {
    countryDialCode: 'KE',
    dialCodeValue: '254',
    dialCodeName: 'Kenya',
    id: '254',
    name: 'Kenya +254',
  },
  {
    countryDialCode: 'KI',
    dialCodeValue: '686',
    dialCodeName: 'Kiribati',
    id: '686',
    name: 'Kiribati +686',
  },
  {
    countryDialCode: 'XK',
    dialCodeValue: '383',
    dialCodeName: 'Kosovo',
    id: '383',
    name: 'Kosovo +383',
  },
  {
    countryDialCode: 'KW',
    dialCodeValue: '965',
    dialCodeName: 'Kuwait (‫الكويت‬‎)',
    id: '965',
    name: 'Kuwait (‫الكويت‬‎) +965',
  },
  {
    countryDialCode: 'KG',
    dialCodeValue: '996',
    dialCodeName: 'Kyrgyzstan (Кыргызстан)',
    id: '996',
    name: 'Kyrgyzstan (Кыргызстан) +996',
  },
  {
    countryDialCode: 'LA',
    dialCodeValue: '856',
    dialCodeName: 'Laos (ລາວ)',
    id: '856',
    name: 'Laos (ລາວ) +856',
  },
  {
    countryDialCode: 'LV',
    dialCodeValue: '371',
    dialCodeName: 'Latvia (Latvija)',
    id: '371',
    name: 'Latvia (Latvija) +371',
  },
  {
    countryDialCode: 'LB',
    dialCodeValue: '961',
    dialCodeName: 'Lebanon (‫لبنان‬‎)',
    id: '961',
    name: 'Lebanon (‫لبنان‬‎) +961',
  },
  {
    countryDialCode: 'LS',
    dialCodeValue: '266',
    dialCodeName: 'Lesotho',
    id: '266',
    name: 'Lesotho +266',
  },
  {
    countryDialCode: 'LR',
    dialCodeValue: '231',
    dialCodeName: 'Liberia',
    id: '231',
    name: 'Liberia +231',
  },
  {
    countryDialCode: 'LY',
    dialCodeValue: '218',
    dialCodeName: 'Libya (‫ليبيا‬‎)',
    id: '218',
    name: 'Libya (‫ليبيا‬‎) +218',
  },
  {
    countryDialCode: 'LI',
    dialCodeValue: '423',
    dialCodeName: 'Liechtenstein',
    id: '423',
    name: 'Liechtenstein +423',
  },
  {
    countryDialCode: 'LT',
    dialCodeValue: '370',
    dialCodeName: 'Lithuania (Lietuva)',
    id: '370',
    name: 'Lithuania (Lietuva) +370',
  },
  {
    countryDialCode: 'LU',
    dialCodeValue: '352',
    dialCodeName: 'Luxembourg',
    id: '352',
    name: 'Luxembourg +352',
  },
  {
    countryDialCode: 'MO',
    dialCodeValue: '853',
    dialCodeName: 'Macau (澳門)',
    id: '853',
    name: 'Macau (澳門) +853',
  },
  {
    countryDialCode: 'MK',
    dialCodeValue: '389',
    dialCodeName: 'Macedonia (FYROM) (Македонија)',
    id: '389',
    name: 'Macedonia (FYROM) (Македонија) +389',
  },
  {
    countryDialCode: 'MG',
    dialCodeValue: '261',
    dialCodeName: 'Madagascar (Madagasikara)',
    id: '261',
    name: 'Madagascar (Madagasikara) +261',
  },
  {
    countryDialCode: 'MW',
    dialCodeValue: '265',
    dialCodeName: 'Malawi',
    id: '265',
    name: 'Malawi +265',
  },
  {
    countryDialCode: 'MY',
    dialCodeValue: '60',
    dialCodeName: 'Malaysia',
    id: '60',
    name: 'Malaysia +60',
  },
  {
    countryDialCode: 'MV',
    dialCodeValue: '960',
    dialCodeName: 'Maldives',
    id: '960',
    name: 'Maldives +960',
  },
  {
    countryDialCode: 'ML',
    dialCodeValue: '223',
    dialCodeName: 'Mali',
    id: '223',
    name: 'Mali +223',
  },
  {
    countryDialCode: 'MT',
    dialCodeValue: '356',
    dialCodeName: 'Malta',
    id: '356',
    name: 'Malta +356',
  },
  {
    countryDialCode: 'MH',
    dialCodeValue: '692',
    dialCodeName: 'Marshall Islands',
    id: '692',
    name: 'Marshall Islands +692',
  },
  {
    countryDialCode: 'MQ',
    dialCodeValue: '596',
    dialCodeName: 'Martinique',
    id: '596',
    name: 'Martinique +596',
  },
  {
    countryDialCode: 'MR',
    dialCodeValue: '222',
    dialCodeName: 'Mauritania (‫موريتانيا‬‎)',
    id: '222',
    name: 'Mauritania (‫موريتانيا‬‎) +222',
  },
  {
    countryDialCode: 'MU',
    dialCodeValue: '230',
    dialCodeName: 'Mauritius (Moris)',
    id: '230',
    name: 'Mauritius (Moris) +230',
  },
  {
    countryDialCode: 'YT',
    dialCodeValue: '262',
    dialCodeName: 'Mayotte',
    id: '262',
    name: 'Mayotte +262',
  },
  {
    countryDialCode: 'MX',
    dialCodeValue: '52',
    dialCodeName: 'Mexico (México)',
    id: '52',
    name: 'Mexico (México) +52',
  },
  {
    countryDialCode: 'FM',
    dialCodeValue: '691',
    dialCodeName: 'Micronesia',
    id: '691',
    name: 'Micronesia +691',
  },
  {
    countryDialCode: 'MD',
    dialCodeValue: '373',
    dialCodeName: 'Moldova (Republica Moldova)',
    id: '373',
    name: 'Moldova (Republica Moldova) +373',
  },
  {
    countryDialCode: 'MC',
    dialCodeValue: '377',
    dialCodeName: 'Monaco',
    id: '377',
    name: 'Monaco +377',
  },
  {
    countryDialCode: 'MN',
    dialCodeValue: '976',
    dialCodeName: 'Mongolia (Монгол)',
    id: '976',
    name: 'Mongolia (Монгол) +976',
  },
  {
    countryDialCode: 'ME',
    dialCodeValue: '382',
    dialCodeName: 'Montenegro (Crna Gora)',
    id: '382',
    name: 'Montenegro (Crna Gora) +382',
  },
  {
    countryDialCode: 'MS',
    dialCodeValue: '1664',
    dialCodeName: 'Montserrat',
    id: '1664',
    name: 'Montserrat +1664',
  },
  {
    countryDialCode: 'MA',
    dialCodeValue: '212',
    dialCodeName: 'Morocco (‫المغرب‬‎)',
    id: '212',
    name: 'Morocco (‫المغرب‬‎) +212',
  },
  {
    countryDialCode: 'MZ',
    dialCodeValue: '258',
    dialCodeName: 'Mozambique (Moçambique)',
    id: '258',
    name: 'Mozambique (Moçambique) +258',
  },
  {
    countryDialCode: 'MM',
    dialCodeValue: '95',
    dialCodeName: 'Myanmar (Burma) (မြန်မာ)',
    id: '95',
    name: 'Myanmar (Burma) (မြန်မာ) +95',
  },
  {
    countryDialCode: 'NA',
    dialCodeValue: '264',
    dialCodeName: 'Namibia (Namibië)',
    id: '264',
    name: 'Namibia (Namibië) +264',
  },
  {
    countryDialCode: 'NR',
    dialCodeValue: '674',
    dialCodeName: 'Nauru',
    id: '674',
    name: 'Nauru +674',
  },
  {
    countryDialCode: 'NP',
    dialCodeValue: '977',
    dialCodeName: 'Nepal (नेपाल)',
    id: '977',
    name: 'Nepal (नेपाल) +977',
  },
  {
    countryDialCode: 'NL',
    dialCodeValue: '31',
    dialCodeName: 'Netherlands (Nederland)',
    id: '31',
    name: 'Netherlands (Nederland) +31',
  },
  {
    countryDialCode: 'NC',
    dialCodeValue: '687',
    dialCodeName: 'New Caledonia (Nouvelle-Calédonie)',
    id: '687',
    name: 'New Caledonia (Nouvelle-Calédonie) +687',
  },
  {
    countryDialCode: 'NZ',
    dialCodeValue: '64',
    dialCodeName: 'New Zealand',
    id: '64',
    name: 'New Zealand +64',
  },
  {
    countryDialCode: 'NI',
    dialCodeValue: '505',
    dialCodeName: 'Nicaragua',
    id: '505',
    name: 'Nicaragua +505',
  },
  {
    countryDialCode: 'NE',
    dialCodeValue: '227',
    dialCodeName: 'Niger (Nijar)',
    id: '227',
    name: 'Niger (Nijar) +227',
  },
  {
    countryDialCode: 'NG',
    dialCodeValue: '234',
    dialCodeName: 'Nigeria',
    id: '234',
    name: 'Nigeria +234',
  },
  {
    countryDialCode: 'NU',
    dialCodeValue: '683',
    dialCodeName: 'Niue',
    id: '683',
    name: 'Niue +683',
  },
  {
    countryDialCode: 'NF',
    dialCodeValue: '672',
    dialCodeName: 'Norfolk Island',
    id: '672',
    name: 'Norfolk Island +672',
  },
  {
    countryDialCode: 'KP',
    dialCodeValue: '850',
    dialCodeName: 'North Korea (조선 민주주의 인민 공화국)',
    id: '850',
    name: 'North Korea (조선 민주주의 인민 공화국) +850',
  },
  {
    countryDialCode: 'MP',
    dialCodeValue: '1670',
    dialCodeName: 'Northern Mariana Islands',
    id: '1670',
    name: 'Northern Mariana Islands +1670',
  },
  {
    countryDialCode: 'NO',
    dialCodeValue: '47',
    dialCodeName: 'Norway (Norge)',
    id: '47',
    name: 'Norway (Norge) +47',
  },
  {
    countryDialCode: 'OM',
    dialCodeValue: '968',
    dialCodeName: 'Oman (‫عُمان‬‎)',
    id: '968',
    name: 'Oman (‫عُمان‬‎) +968',
  },
  {
    countryDialCode: 'PK',
    dialCodeValue: '92',
    dialCodeName: 'Pakistan (‫پاکستان‬‎)',
    id: '92',
    name: 'Pakistan (‫پاکستان‬‎) +92',
  },
  {
    countryDialCode: 'PW',
    dialCodeValue: '680',
    dialCodeName: 'Palau',
    id: '680',
    name: 'Palau +680',
  },
  {
    countryDialCode: 'PS',
    dialCodeValue: '970',
    dialCodeName: 'Palestine (‫فلسطين‬‎)',
    id: '970',
    name: 'Palestine (‫فلسطين‬‎) +970',
  },
  {
    countryDialCode: 'PA',
    dialCodeValue: '507',
    dialCodeName: 'Panama (Panamá)',
    id: '507',
    name: 'Panama (Panamá) +507',
  },
  {
    countryDialCode: 'PG',
    dialCodeValue: '675',
    dialCodeName: 'Papua New Guinea',
    id: '675',
    name: 'Papua New Guinea +675',
  },
  {
    countryDialCode: 'PY',
    dialCodeValue: '595',
    dialCodeName: 'Paraguay',
    id: '595',
    name: 'Paraguay +595',
  },
  {
    countryDialCode: 'PE',
    dialCodeValue: '51',
    dialCodeName: 'Peru (Perú)',
    id: '51',
    name: 'Peru (Perú) +51',
  },
  {
    countryDialCode: 'PH',
    dialCodeValue: '63',
    dialCodeName: 'Philippines',
    id: '63',
    name: 'Philippines +63',
  },
  {
    countryDialCode: 'PL',
    dialCodeValue: '48',
    dialCodeName: 'Poland (Polska)',
    id: '48',
    name: 'Poland (Polska) +48',
  },
  {
    countryDialCode: 'PT',
    dialCodeValue: '351',
    dialCodeName: 'Portugal',
    id: '351',
    name: 'Portugal +351',
  },
  {
    countryDialCode: 'PR',
    dialCodeValue: '1',
    dialCodeName: 'Puerto Rico',
    id: '1',
    name: 'Puerto Rico +1',
  },
  {
    countryDialCode: 'QA',
    dialCodeValue: '974',
    dialCodeName: 'Qatar (‫قطر‬‎)',
    id: '974',
    name: 'Qatar (‫قطر‬‎) +974',
  },
  {
    countryDialCode: 'RO',
    dialCodeValue: '40',
    dialCodeName: 'Romania (România)',
    id: '40',
    name: 'Romania (România) +40',
  },
  {
    countryDialCode: 'RU',
    dialCodeValue: '7',
    dialCodeName: 'Russia (Россия)',
    id: '7',
    name: 'Russia (Россия) +7',
  },
  {
    countryDialCode: 'RW',
    dialCodeValue: '250',
    dialCodeName: 'Rwanda',
    id: '250',
    name: 'Rwanda +250',
  },
  {
    countryDialCode: 'RE',
    dialCodeValue: '262',
    dialCodeName: 'Réunion (La Réunion)',
    id: '262',
    name: 'Réunion (La Réunion) +262',
  },
  {
    countryDialCode: 'BL',
    dialCodeValue: '590',
    dialCodeName: 'Saint Barthélemy',
    id: '590',
    name: 'Saint Barthélemy +590',
  },
  {
    countryDialCode: 'SH',
    dialCodeValue: '290',
    dialCodeName: 'Saint Helena',
    id: '290',
    name: 'Saint Helena +290',
  },
  {
    countryDialCode: 'KN',
    dialCodeValue: '1869',
    dialCodeName: 'Saint Kitts and Nevis',
    id: '1869',
    name: 'Saint Kitts and Nevis +1869',
  },
  {
    countryDialCode: 'LC',
    dialCodeValue: '1758',
    dialCodeName: 'Saint Lucia',
    id: '1758',
    name: 'Saint Lucia +1758',
  },
  {
    countryDialCode: 'MF',
    dialCodeValue: '590',
    dialCodeName: 'Saint Martin (Saint-Martin (partie française))',
    id: '590',
    name: 'Saint Martin (Saint-Martin (partie française)) +590',
  },
  {
    countryDialCode: 'PM',
    dialCodeValue: '508',
    dialCodeName: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
    id: '508',
    name: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon) +508',
  },
  {
    countryDialCode: 'VC',
    dialCodeValue: '1784',
    dialCodeName: 'Saint Vincent and the Grenadines',
    id: '1784',
    name: 'Saint Vincent and the Grenadines +1784',
  },
  {
    countryDialCode: 'WS',
    dialCodeValue: '685',
    dialCodeName: 'Samoa',
    id: '685',
    name: 'Samoa +685',
  },
  {
    countryDialCode: 'SM',
    dialCodeValue: '378',
    dialCodeName: 'San Marino',
    id: '378',
    name: 'San Marino +378',
  },
  {
    countryDialCode: 'SA',
    dialCodeValue: '966',
    dialCodeName: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
    id: '966',
    name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎) +966',
  },
  {
    countryDialCode: 'SN',
    dialCodeValue: '221',
    dialCodeName: 'Senegal (Sénégal)',
    id: '221',
    name: 'Senegal (Sénégal) +221',
  },
  {
    countryDialCode: 'RS',
    dialCodeValue: '381',
    dialCodeName: 'Serbia (Србија)',
    id: '381',
    name: 'Serbia (Србија) +381',
  },
  {
    countryDialCode: 'SC',
    dialCodeValue: '248',
    dialCodeName: 'Seychelles',
    id: '248',
    name: 'Seychelles +248',
  },
  {
    countryDialCode: 'SL',
    dialCodeValue: '232',
    dialCodeName: 'Sierra Leone',
    id: '232',
    name: 'Sierra Leone +232',
  },
  {
    countryDialCode: 'SG',
    dialCodeValue: '65',
    dialCodeName: 'Singapore',
    id: '65',
    name: 'Singapore +65',
  },
  {
    countryDialCode: 'SX',
    dialCodeValue: '1721',
    dialCodeName: 'Sint Maarten',
    id: '1721',
    name: 'Sint Maarten +1721',
  },
  {
    countryDialCode: 'SK',
    dialCodeValue: '421',
    dialCodeName: 'Slovakia (Slovensko)',
    id: '421',
    name: 'Slovakia (Slovensko) +421',
  },
  {
    countryDialCode: 'SI',
    dialCodeValue: '386',
    dialCodeName: 'Slovenia (Slovenija)',
    id: '386',
    name: 'Slovenia (Slovenija) +386',
  },
  {
    countryDialCode: 'SB',
    dialCodeValue: '677',
    dialCodeName: 'Solomon Islands',
    id: '677',
    name: 'Solomon Islands +677',
  },
  {
    countryDialCode: 'SO',
    dialCodeValue: '252',
    dialCodeName: 'Somalia (Soomaaliya)',
    id: '252',
    name: 'Somalia (Soomaaliya) +252',
  },
  {
    countryDialCode: 'ZA',
    dialCodeValue: '27',
    dialCodeName: 'South Africa',
    id: '27',
    name: 'South Africa +27',
  },
  {
    countryDialCode: 'KR',
    dialCodeValue: '82',
    dialCodeName: 'South Korea (대한민국)',
    id: '82',
    name: 'South Korea (대한민국) +82',
  },
  {
    countryDialCode: 'SS',
    dialCodeValue: '211',
    dialCodeName: 'South Sudan (‫جنوب السودان‬‎)',
    id: '211',
    name: 'South Sudan (‫جنوب السودان‬‎) +211',
  },
  {
    countryDialCode: 'ES',
    dialCodeValue: '34',
    dialCodeName: 'Spain (España)',
    id: '34',
    name: 'Spain (España) +34',
  },
  {
    countryDialCode: 'LK',
    dialCodeValue: '94',
    dialCodeName: 'Sri Lanka (ශ්‍රී ලංකාව)',
    id: '94',
    name: 'Sri Lanka (ශ්‍රී ලංකාව) +94',
  },
  {
    countryDialCode: 'SD',
    dialCodeValue: '249',
    dialCodeName: 'Sudan (‫السودان‬‎)',
    id: '249',
    name: 'Sudan (‫السودان‬‎) +249',
  },
  {
    countryDialCode: 'SR',
    dialCodeValue: '597',
    dialCodeName: 'Suriname',
    id: '597',
    name: 'Suriname +597',
  },
  {
    countryDialCode: 'SJ',
    dialCodeValue: '47',
    dialCodeName: 'Svalbard and Jan Mayen',
    id: '47',
    name: 'Svalbard and Jan Mayen +47',
  },
  {
    countryDialCode: 'SZ',
    dialCodeValue: '268',
    dialCodeName: 'Swaziland',
    id: '268',
    name: 'Swaziland +268',
  },
  {
    countryDialCode: 'SE',
    dialCodeValue: '46',
    dialCodeName: 'Sweden (Sverige)',
    id: '46',
    name: 'Sweden (Sverige) +46',
  },
  {
    countryDialCode: 'CH',
    dialCodeValue: '41',
    dialCodeName: 'Switzerland (Schweiz)',
    id: '41',
    name: 'Switzerland (Schweiz) +41',
  },
  {
    countryDialCode: 'SY',
    dialCodeValue: '963',
    dialCodeName: 'Syria (‫سوريا‬‎)',
    id: '963',
    name: 'Syria (‫سوريا‬‎) +963',
  },
  {
    countryDialCode: 'ST',
    dialCodeValue: '239',
    dialCodeName: 'São Tomé and Príncipe (São Tomé e Príncipe)',
    id: '239',
    name: 'São Tomé and Príncipe (São Tomé e Príncipe) +239',
  },
  {
    countryDialCode: 'TW',
    dialCodeValue: '886',
    dialCodeName: 'Taiwan (台灣)',
    id: '886',
    name: 'Taiwan (台灣) +886',
  },
  {
    countryDialCode: 'TJ',
    dialCodeValue: '992',
    dialCodeName: 'Tajikistan',
    id: '992',
    name: 'Tajikistan +992',
  },
  {
    countryDialCode: 'TZ',
    dialCodeValue: '255',
    dialCodeName: 'Tanzania',
    id: '255',
    name: 'Tanzania +255',
  },
  {
    countryDialCode: 'TH',
    dialCodeValue: '66',
    dialCodeName: 'Thailand (ไทย)',
    id: '66',
    name: 'Thailand (ไทย) +66',
  },
  {
    countryDialCode: 'TL',
    dialCodeValue: '670',
    dialCodeName: 'Timor-Leste',
    id: '670',
    name: 'Timor-Leste +670',
  },
  {
    countryDialCode: 'TG',
    dialCodeValue: '228',
    dialCodeName: 'Togo',
    id: '228',
    name: 'Togo +228',
  },
  {
    countryDialCode: 'TK',
    dialCodeValue: '690',
    dialCodeName: 'Tokelau',
    id: '690',
    name: 'Tokelau +690',
  },
  {
    countryDialCode: 'TO',
    dialCodeValue: '676',
    dialCodeName: 'Tonga',
    id: '676',
    name: 'Tonga +676',
  },
  {
    countryDialCode: 'TT',
    dialCodeValue: '1868',
    dialCodeName: 'Trinidad and Tobago',
    id: '1868',
    name: 'Trinidad and Tobago +1868',
  },
  {
    countryDialCode: 'TN',
    dialCodeValue: '216',
    dialCodeName: 'Tunisia (‫تونس‬‎)',
    id: '216',
    name: 'Tunisia (‫تونس‬‎) +216',
  },
  {
    countryDialCode: 'TR',
    dialCodeValue: '90',
    dialCodeName: 'Turkey (Türkiye)',
    id: '90',
    name: 'Turkey (Türkiye) +90',
  },
  {
    countryDialCode: 'TM',
    dialCodeValue: '993',
    dialCodeName: 'Turkmenistan',
    id: '993',
    name: 'Turkmenistan +993',
  },
  {
    countryDialCode: 'TC',
    dialCodeValue: '1649',
    dialCodeName: 'Turks and Caicos Islands',
    id: '1649',
    name: 'Turks and Caicos Islands +1649',
  },
  {
    countryDialCode: 'TV',
    dialCodeValue: '688',
    dialCodeName: 'Tuvalu',
    id: '688',
    name: 'Tuvalu +688',
  },
  {
    countryDialCode: 'VI',
    dialCodeValue: '1340',
    dialCodeName: 'U.S. Virgin Islands',
    id: '1340',
    name: 'U.S. Virgin Islands +1340',
  },
  {
    countryDialCode: 'UG',
    dialCodeValue: '256',
    dialCodeName: 'Uganda',
    id: '256',
    name: 'Uganda +256',
  },
  {
    countryDialCode: 'UA',
    dialCodeValue: '380',
    dialCodeName: 'Ukraine (Україна)',
    id: '380',
    name: 'Ukraine (Україна) +380',
  },
  {
    countryDialCode: 'AE',
    dialCodeValue: '971',
    dialCodeName: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
    id: '971',
    name: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎) +971',
  },
  {
    countryDialCode: 'GB',
    dialCodeValue: '44',
    dialCodeName: 'United Kingdom',
    id: '44',
    name: 'United Kingdom +44',
  },
  {
    countryDialCode: 'US',
    dialCodeValue: '1',
    dialCodeName: 'United States',
    id: '1',
    name: 'United States +1',
  },
  {
    countryDialCode: 'UY',
    dialCodeValue: '598',
    dialCodeName: 'Uruguay',
    id: '598',
    name: 'Uruguay +598',
  },
  {
    countryDialCode: 'UZ',
    dialCodeValue: '998',
    dialCodeName: 'Uzbekistan (Oʻzbekiston)',
    id: '998',
    name: 'Uzbekistan (Oʻzbekiston) +998',
  },
  {
    countryDialCode: 'VU',
    dialCodeValue: '678',
    dialCodeName: 'Vanuatu',
    id: '678',
    name: 'Vanuatu +678',
  },
  {
    countryDialCode: 'VA',
    dialCodeValue: '39',
    dialCodeName: 'Vatican City (Città del Vaticano)',
    id: '39',
    name: 'Vatican City (Città del Vaticano) +39',
  },
  {
    countryDialCode: 'VE',
    dialCodeValue: '58',
    dialCodeName: 'Venezuela',
    id: '58',
    name: 'Venezuela +58',
  },
  {
    countryDialCode: 'VN',
    dialCodeValue: '84',
    dialCodeName: 'Vietnam (Việt Nam)',
    id: '84',
    name: 'Vietnam (Việt Nam) +84',
  },
  {
    countryDialCode: 'WF',
    dialCodeValue: '681',
    dialCodeName: 'Wallis and Futuna (Wallis-et-Futuna)',
    id: '681',
    name: 'Wallis and Futuna (Wallis-et-Futuna) +681',
  },
  {
    countryDialCode: 'EH',
    dialCodeValue: '212',
    dialCodeName: 'Western Sahara (‫الصحراء الغربية‬‎)',
    id: '212',
    name: 'Western Sahara (‫الصحراء الغربية‬‎) +212',
  },
  {
    countryDialCode: 'YE',
    dialCodeValue: '967',
    dialCodeName: 'Yemen (‫اليمن‬‎)',
    id: '967',
    name: 'Yemen (‫اليمن‬‎) +967',
  },
  {
    countryDialCode: 'ZM',
    dialCodeValue: '260',
    dialCodeName: 'Zambia',
    id: '260',
    name: 'Zambia +260',
  },
  {
    countryDialCode: 'ZW',
    dialCodeValue: '263',
    dialCodeName: 'Zimbabwe',
    id: '263',
    name: 'Zimbabwe +263',
  },
  {
    countryDialCode: 'AX',
    dialCodeValue: '358',
    dialCodeName: 'Åland Islands',
    id: '358',
    name: 'Åland Islands +358',
  },
];
